import { ChangeEvent, useMemo, useState } from 'react';
import { DropDown } from '../../../component/dropDown';
import { EmptyState, EmptyTxt } from '../../../component/emptyState';
import { Loader } from '../../../component/loader';
import { DeleteModal } from '../../../component/modal/deleteModal';
import {
  useDeletePropertyMutation,
  useGetAllPropertiesQuery
} from '../../../store/realEstate/api';
import { propertyType } from '../../../utils/module';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { generateUrl } from '../../../utils/urlGenerator';
import { PropertyListCard } from './component/propertyListCard';
import searchIcon from '../../../assets/Search.svg';
import { AddProperty } from './component/propertyModals/addProperty';
import {
  AddPropertyBtn,
  Container,
  Header,
  ListContainer,
  SearchBar,
  SearchContainer,
  SearchIcon,
  SortContainer,
  Title
} from './styles';
import { Paginate } from '../../../component/pagenate';
import useDebounce from '../../../utils/useDebounce';

export const AllProperties = () => {
  const [sortBy, setSortBy] = useState('');
  const [addPropertyModal, setAddPropertyModal] = useState(false);
  const [deletePropertyModal, setDeletePropertyModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const debounceSearchProperty = useDebounce(searchValue, 500);
  const [propertyId, setPropertyId] = useState<string>('');

  const [deleteProperty, { isLoading: isDeletePropertyLoading }] =
    useDeletePropertyMutation();
  const propertyDetails = useMemo(
    () =>
      generateUrl({
        type: sortBy.toLowerCase().replace(' ', '-'),
        pageSize: '6',
        search: debounceSearchProperty,
        pageNo: pageNumber.toString()
      }),
    [sortBy, pageNumber, debounceSearchProperty]
  );
  const { data: allPropertyList, isLoading: isPropertiesLoading } =
    useGetAllPropertiesQuery(propertyDetails);
  const handleAddProperty = () => {
    setAddPropertyModal(true);
  };
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const handleDeleteProperty = (itemId: string) => {
    setDeletePropertyModal(true);
    setPropertyId(itemId);
  };
  const handlePropertyDelete = () => {
    deleteProperty(propertyId)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setDeletePropertyModal(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };
  return (
    <Container>
      {isPropertiesLoading && <Loader />}
      {addPropertyModal && <AddProperty setShow={setAddPropertyModal} />}
      {deletePropertyModal && (
        <DeleteModal
          deleteTitle="Delete Property"
          isLoading={isDeletePropertyLoading}
          deleteText="Are you sure you want to delete this property, this action can’t be undone?"
          cancelBtnClick={() => setDeletePropertyModal(false)}
          deleteBtnClick={handlePropertyDelete}
        />
      )}
      <Header>
        <Title>All Properties</Title>
        <SortContainer>
          <SearchContainer>
            <SearchIcon src={searchIcon} alt="" />
            <SearchBar
              type={'text'}
              placeholder=" Search for Item"
              onChange={handleSearchChange}
              value={searchValue}
            />
          </SearchContainer>
          <DropDown
            value={sortBy}
            placeholder={'All Properties'}
            onSelect={(item) => {
              setSortBy(item === 'All Properties' ? '' : item);
            }}
            options={['All Properties', ...propertyType]}
          />
          <AddPropertyBtn onClick={() => handleAddProperty()}>
            Add property
          </AddPropertyBtn>
        </SortContainer>
      </Header>
      {allPropertyList?.data.fetchedData.length ? (
        <ListContainer>
          {allPropertyList?.data.fetchedData.map((item, index) => (
            <PropertyListCard
              handleDelete={() => handleDeleteProperty(item._id)}
              propertyItem={item}
              key={index.toString()}
            />
          ))}
        </ListContainer>
      ) : (
        <EmptyState>
          <EmptyTxt>
            No real-estate property yet, click on the button below to add
            property
          </EmptyTxt>
          <AddPropertyBtn onClick={() => handleAddProperty()}>
            Add property
          </AddPropertyBtn>
        </EmptyState>
      )}
      {!!allPropertyList?.data.fetchedData.length && (
        <Paginate
          pageNo={allPropertyList.data.pageNo}
          noOfPages={allPropertyList.data.noOfPages}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
      )}
    </Container>
  );
};
